import { EnrollmentStatusActionsCreators, EnrollmentStatusActionType } from './types/actions';


const enrollmentStatusActionsCreators: EnrollmentStatusActionsCreators = {
  fetchEnrollmentStatus: ({ fieldTractId, tenantId, programId }) => ({
    type: EnrollmentStatusActionType.FetchEnrollmentStatus,
    payload: { fieldTractId, tenantId, programId }
  }),
  fetchEnrollmentStatusRejected: (error) => ({
    type: EnrollmentStatusActionType.FetchEnrollmentStatusRejected,
    payload: { error }
  }),
  fetchEnrollmentStatusResolved: (programEnrollments) => ({
    type: EnrollmentStatusActionType.FetchEnrollmentStatusResolved,
    payload: programEnrollments,
  }),
};

export default enrollmentStatusActionsCreators;
